module.exports = __webpack_public_path__ + "img/close.c8aab09d.svg";